import ui from "@alpinejs/ui";
import { Livewire, Alpine } from "../../vendor/livewire/livewire/dist/livewire.esm";
import registerDocs from "./docs";
import { trackFathomViewsOnLoad } from "./fathom-views";
import urlTabs from "./url-tabs";
import geoCountrySelection from "./geo-country-selection";
import syncDroppedFilesIntoNativeForms from "./file-upload-native-forms";
import autosize from "./autosize";

Alpine.plugin(ui);
registerDocs(Alpine);
Alpine.data("urlTabs", urlTabs);
Alpine.data("geoCountrySelection", geoCountrySelection);
Alpine.plugin(autosize);

// Textos de la interfaz que pinta el JS: los traduce el layout en `window.HostsuarLang`.
const lang = (key) => (window.HostsuarLang || {})[key] ?? key;

window.copyToClipboard = function (elementIdOrText, button, successMessage = lang("¡Copiado!")) {
    let text;

    const element = document.getElementById(elementIdOrText);
    if (element) {
        text = element.textContent;
    } else {
        text = elementIdOrText;
    }

    if (!text) {
        console.error("No text to copy");
        return;
    }

    const showSuccess = () => {
        if (button) {
            const originalText = button.textContent;
            button.textContent = successMessage;
            setTimeout(() => {
                button.textContent = originalText;
            }, 2000);
        }
    };

    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
            .writeText(text)
            .then(() => showSuccess())
            .catch((err) => {
                console.error("Clipboard API failed:", err);
                fallbackCopy(text, button, successMessage);
            });
    } else {
        fallbackCopy(text, button, successMessage);
    }
};

function fallbackCopy(text, button, successMessage) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.select();

    try {
        const successful = document.execCommand("copy");
        if (successful && button) {
            const originalText = button.textContent;
            button.textContent = successMessage;
            setTimeout(() => {
                button.textContent = originalText;
            }, 2000);
        }
    } catch (err) {
        console.error("Fallback copy failed:", err);
    }

    document.body.removeChild(textArea);
}

function trackFathomEvent(name) {
    if (name && window.fathom) {
        window.fathom.trackEvent(name);
    }
}

document.addEventListener("click", (event) => {
    const element = event.target instanceof Element ? event.target.closest("[data-fathom-event]") : null;

    if (element) {
        trackFathomEvent(element.dataset.fathomEvent);
    }
});

trackFathomViewsOnLoad();
syncDroppedFilesIntoNativeForms();

window.Alpine = Alpine;

Livewire.start();
